import { render, staticRenderFns } from "./FirstInfos.vue?vue&type=template&id=2836a006&scoped=true&"
import script from "./FirstInfos.vue?vue&type=script&lang=js&"
export * from "./FirstInfos.vue?vue&type=script&lang=js&"
import style0 from "./FirstInfos.vue?vue&type=style&index=0&id=2836a006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836a006",
  null
  
)

export default component.exports